module.exports = __webpack_public_path__ + "img/6.a61b1a53.jpg";